module.exports = __webpack_public_path__ + "static/media/ReCap Photo.8663dc87.png";